<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="anonymiser.icon" class="mr-1"></i>
            <span>{{ anonymiser.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm" class="mb-0">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <span style="padding-top: 0.3em" class="text-primary" id="slaclike-tooltip">Like</span>
                    <b-form-checkbox id="slaclike" v-model="slaclike_visible" class="z-0">
                    </b-form-checkbox>
                  </b-input-group>
                  <b-input-group v-if="!slaclike_visible">
                    <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                      :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested :disabled="readonly">
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-input-group>
                </b-form-group>
                <!-- <b-form-group
                  label-cols="12"
                  label="SL A/C (LIKE %)"
                  label-size="sm"
                > -->
                <b-input-group v-if="slaclike_visible">
                  <b-form-input v-model="slaclike" :debounce="anonymiser.debounce" placeholder="Client SL A/C (LIKE %)"
                    trim></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" :disabled="!slaclike" @click="slaclike = ''">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <!-- </b-form-group> -->
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Surname" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="surname" :debounce="anonymiser.debounce" placeholder="Surname"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!surname" @click="surname = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="First Name" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="firstname" :debounce="anonymiser.debounce" placeholder="First Name"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!firstname" @click="firstname = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Profile ID" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="ref" :debounce="anonymiser.debounce" placeholder="Profile ID"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!ref" @click="ref = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Anonymised ID" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="key" :debounce="anonymiser.debounce" placeholder="Anonymised ID"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!key" @click="key = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Aka (Also Known As)" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="aka" :debounce="anonymiser.debounce" placeholder="Aka" trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!aka" @click="aka = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Category" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="category" :debounce="anonymiser.debounce" placeholder="Category"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!category" @click="category = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Exclude?" label-for="exclude" label-cols="12">
                  <treeselect v-model="exclude" :clearable="true" :options="options_exclude" placeholder="Show all...">
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Query duplicates with" label-size="sm">
                  <treeselect id="query" placeholder="Select query..." :clearable="true" v-model="query"
                    :options="query_options" :disable-branch-nodes="true" :show-count="true"
                    :default-expand-level="1" :disabled="slac.length>0?false:true" />
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="anonymiser" :icon="anonymiser.icon"
            :busy="anonymiser.busy" :toolbarlibrary="anonymiser.toolbarlibrary" :tools="anonymiser.tools"
            :badges="anonymiser.badges" :fields="anonymiser.fields" :items="anonymiser.items"
            :offset="anonymiser.offset" :limit="anonymiser.limit" :page="anonymiser.page" @load="anonymiser_load"
            @click="anonymiser_click" @changed="anonymiser_click('save', $event)" @select="anonymiser_select">
          </d-table>
        </div>
      </div>

      <!-- @go="anonymiser_click('go')" -->
      <div v-show="component">
        <component :is="component" :selection="anonymiser.selected" :config="cconfig"
          @discard="anonymiser_click('discard')" @refresh="anonymiser_click('refresh')"></component>
      </div>
    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

import AnonymiserEdit from "./Components/AnonymiserEdit";
import AnonymiserSame from "./Components/AnonymiserSame";

export default {
  name: "Anonymiser",
  components: { AnonymiserEdit, AnonymiserSame },
  watch: {
    async slac() {
      this.query = null
      await this.anonymiser_load(0);
    },
    async slaclike_visible() {
      await this.anonymiser_load(0);
    },
    async slaclike() {
      await this.anonymiser_load(0);
    },
    async surname() {
      await this.anonymiser_load(0);
    },
    async firstname() {
      await this.anonymiser_load(0);
    },
    async ref() {
      await this.anonymiser_load(0);
    },
    async key() {
      await this.anonymiser_load(0);
    },
    async category() {
      await this.anonymiser_load(0);
    },
    async aka() {
      await this.anonymiser_load(0);
    },
    async exclude() {
      await this.anonymiser_load(0);
    },
    async query() {
      await this.anonymiser_load(0);
    },
  },
  data() {
    return {
      surname: null,
      slac: [],
      slaclike: null,
      slaclike_visible: null,
      firstname: null,
      ref: null,
      key: null,
      category: null,
      aka: null,
      exclude: null,
      query: null,
      query_options: [
        { id: null, label: "All " },
        { id: "slac-firstname4", label: "SLAC SURNAME/####" }
      ],
      options_exclude: [
        { id: false, label: "No" },
        { id: true, label: "Yes" },
      ],
      anonymiser: {
        title: "Anonymiser",
        icon: "fa fa-user-secret",
        debounce: 500,
        busy: false,
        denied: [],
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,export,clipboard,add,edit,deleteconfirm,anonymisersame",
        toolbarlibrary: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right w-50px",
          },

          {
            key: "key",
            label: "Anonymised ID",
            sortable: true,
            class: "text-left",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "text-left",
          },
          {
            key: "surname",
            label: "Surname",
            sortable: true,
            class: "text-left",
          },
          {
            key: "firstname",
            label: "First Name",
            sortable: true,
            class: "text-left",
          },
          {
            key: "ref",
            label: "Profile ID",
            sortable: true,
            class: "text-left",
          },
          {
            key: "exclude",
            label: "Exclude?",
            sortable: true,
          },
          {
            key: "category",
            label: "Category",
            sortable: true,
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          {
            key: "category",
            type: "pill",
            class: "white",
          },
          {
            key: "exclude",
            type: "badge",
            No: "success",
            Yes: "danger",
            formatter: (value, key, item) => {
              switch (value) {
                case false:
                  return "No";
                  break;
                case true:
                  return "Yes";
                  break;
                default:
                  return value;
              }
            },
          },
        ],
        items: [],
        selected: [],
      },
    };
  },
  async mounted() {
    this.accessdenied();
    await this.anonymiser_load();
  },

  methods: {
    accessdenied() {
      this.anonymiser.denied = [];
      if (!this.user.permissions.includes("anonymiser.delete")) {
        this.anonymiser.denied.push("deleteconfirm");
      }
    },
    async anonymiser_load(offset, limit, page) {

      let state = this.anonymiser;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,
        slac: this.slac.length > 0 ? this.slac.join(",") : null,
        slaclike: this.slaclike,
        firstname: this.firstname,
        surname: this.surname,
        ref: this.ref,
        key: this.key,
        category: this.category,
        aka: this.aka,
        exclude: this.exclude,
        query: this.query ? this.query : null,
        dateformat: "DD/MM/YYYY",
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query anonymiser(
              $limit: Int
              $offset: Int
              $slac: String
              $slaclike: String
              $surname: String
              $firstname: String
              $ref: String
              $key: String
              $category: String
              $aka: String
              $exclude: Boolean
              $query: String
              $dateformat: String
            ) {
              anonymiser(
                limit: $limit
                offset: $offset
                slac: $slac
                slaclike: $slaclike
                surname: $surname
                firstname: $firstname
                ref: $ref
                key: $key
                category: $category
                aka: $aka
                exclude: $exclude
                query: $query
                dateformat: $dateformat
              ) {
                id
                key
                slac
                firstname
                surname
                title
                ref
                category
                aka
                exclude
                updated_at
                updated_by
                rows
              }
            }
          `,
          variables,
        });

        // USE LOCAL VARIABLE
        if (limit == 0) {
          state.selected = response.data.anonymiser
        } else {
          state.items = []
          state.items = response.data.anonymiser;
        }


      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async anonymiser_click(a, ss) {

      switch (a) {
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
          this.component = null;
          break;

        case "refresh":
        case "go":
          this.component = null;
          this.anonymiser_load();
          break;
        case "add":
        case "edit":
          this.component = "AnonymiserEdit";
          break;
        case "anonymisersame":
          this.component = "AnonymiserSame";
          break;

        case "save":
          this.saveit(ss);
          break;

        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async anonymiser_select(ss, tools) {

      let state = this.anonymiser;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "export","clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm", "anonymisersame"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async saveit(ss) {
      // let requirement = { ...this.requirement_bookerinitial };


      // let requirements = "";
      // for (var prop in requirement) {
      //   if (this.item[prop] == null) {
      //     requirements += requirement[prop] + ", ";
      //     // break;
      //   }
      // }
      // if (requirements.length > 0) {
      //   this.message =
      //     "<span class='text-danger'>" +
      //     requirements.slice(0, -1) +
      //     " required field(s). </span>";
      //   return;
      // }
      this.busy = true;

      let variables = { rows: this.cleanit(ss) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation anonymiser_save($rows: [anonymiser_input]) {
              anonymiser_save(rows: $rows) {
                id
                key
                slac
                ref
                firstname
                surname
                title
                category
                aka
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation anonymiser_delete($rows: [anonymiser_input]) {
              anonymiser_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.anonymiser_load(0);
    },
  },
};
</script>

<style></style>